import React, { Component, version } from "react";
import { UserContext } from "../auth/providers";
//#region package Import
import swal from "sweetalert";
import ReactPlayer from "react-player";
//#endregion

//#region importing components
import Menu from "./Menu/Menu";
import MyProfile from "./MyProfile/MyProfile";
import Scene from "../common/Scene/Scene";
import QNA from "../Qna/App1";
import PublicPoll from "../Poll/PublicPoll";
//#endregion

//#region Const import
import {
  AnalyticsLocations,
  HotspotType,
  StaticLinks,
} from "../../const/fixed/Types";
import {
  AudiData,
  DBRData,
  LobbyHotspots,
  LobbyHotspotsId,
  TeamsData,
} from "../../data/Lobby/hotspots";
import {
  SubMenuId,
  menuItems,
  menuItemsId,
  menuItemsIndex,
  NetworkingSubmenuId,
  DBRSubMenuIndex,
} from "../../const/Menu/MenuConst";
import { VideoString } from "../../const/assets/VideoString";
import { ImageString } from "../../const/assets/ImageString";
import VideoPlayer from "../common/videoPlayer/VideoPlayer";
import AudiScene from "../common/AudiScene/AudiScene";
import {
  firestore,
  updateUserLocation,
  addRealtimeHotspotAnalytics,
  checkForDailycoAdmin,
  getDailycoRoomDetails,
  checkDailycoRoomStatus,
  getAvailableTwilioVideoCallRoom,
  clearTwilioVideoCallRoom,
  addCustomRealtimeHotspotAnalytics,
  getLinkListener,
} from "../firebase/firebase";
import LobbyTut from "./Tut/LobbyTut";
import ReactAudioPlayer from "react-audio-player";
import CustomNotification from "../common/CustomNotification/CustomNotification";
import AudiTut from "./Tut/AudiTut";
import NetworkingTut from "./Tut/NetworkingTut";
import ClientChat from "../client-chat/ClientChat";
import ListContainer from "./ListContainer/ListContainer";
import PdfPlayer from "../common/PdfPlayer/PdfPlayer";
import MultiVideoCall from "../videoCalling/MultiVideoCall";
import { AppString } from "../firebase/AppString";
import DBRTut from "./Tut/DBRTut";
//#endregion

const videoRatios = 2.33;

class Home extends Component {
  state = {
    UI: {
      menuItems: menuItems,
      activeMenu: menuItems[0],
      activeSubMenu: null,
      lastMenu: menuItems[0],
      overlayMenu: null,
      MenuVisible: true,
      isInteractable: false,
      showMediaModal: false,
      clicked: false,
      showHelpdeskChat: false,
      showLeaderboard: false,
      showLeaderboardButton: true,

      showSurveyPopup: false,
      surveyDetails: null,

      showDBRSidePanel: true,

      showStallChat: false,

      showGlobalChat: false,
    },
    HelpdeskChat: {
      showChat: false,
      showButton: true,
    },
    MediaModalInfo: {
      link: "",
      type: null,
    },
    DBRVideoCall: {
      roomOptions: { t1: { publicRoomName: "team3" } },
      room: null,
      showVideoCall: false,
      roomAdmin: null,
    },
    TwilioVideoCall: {
      slot: null,
      room: null,
      showVideoCall: false,
    },
    stallChat: {
      id: "",
    },
    audiLnk: AudiData.link,
    zoomlink: DBRData.zoomlink,
  };
  currentOverlayCallback = null;
  currentAudioRef = React.createRef();
  AudioListenerRemoved = false;

  componentDidMount = () => {
    window.c = this;
    window.addEventListener("click", this.playIntroAudio);
    this.dailycoSetup();
    this.gettingMeetingRoomErrMessage();
    window.zoomlink = DBRData.zoomlink;
    getLinkListener((err, data) => {
      if (err) {
        console.log(err);
        return;
      }
      window.zoomlink = data.DBRData.zoomlink;
      this.setState({
        audiLnk: data.AudiData.link,
        zoomlink: data.DBRData.zoomlink,
      });
    });
  };

  componentWillUnmount() {
    if (!this.AudioListenerRemoved) {
      this.AudioListenerRemoved = true;
      window.removeEventListener("click", this.playIntroAudio);
    }
  }

  playIntroAudio = () => {
    console.log(this.currentAudioRef);
    if (this.currentAudioRef.current)
      this.currentAudioRef.current.audioEl.current.play();
    this.AudioListenerRemoved = true;
    window.removeEventListener("click", this.playIntroAudio);
  };

  //#region UI Function
  showInfoPopUp(message) {
    swal({
      title: message,
      icon: "info",
      className: "video-swal-modal",
      button: "continue",
    });
  }

  openLastMenu = (event) => {
    if (event) event.preventDefault();
    this.setState((state) => ({
      UI: { ...state.UI, activeMenu: state.UI.lastMenu, overlayMenu: null },
    }));
  };

  handleCustomHotspotClick = (event, hotspotDetails) => {
    if (event) event.preventDefault();

    console.log(hotspotDetails.links);
    if (hotspotDetails.id === LobbyHotspotsId.Survey) {
      this.setState((state) => ({
        UI: {
          ...state.UI,
          showSurveyPopup: true,
          surveyDetails: hotspotDetails.links,
        },
      }));
    }
  };

  handleClick = (event, item, overlayCloseCallback) => {
    if (event) event.preventDefault();
    this.closeMediaModal();
    if (this.state.UI.overlayMenu) {
      if (item.id === this.state.UI.overlayMenu.id) {
        return;
      }
    } else if (item.id === this.state.UI.activeMenu.id) {
      return;
    }

    if (overlayCloseCallback) {
      this.currentOverlayCallback = overlayCloseCallback;
    }

    if (
      item.id !== menuItemsId.MyProfile &&
      item.id !== menuItemsId.TeamBuilding &&
      item.id !== menuItemsId.bdr
    ) {
      this.handleHelpdeskChatClose();
      this.setState((state) => ({
        UI: {
          ...state.UI,
          activeMenu: item,
          overlayMenu: null,
          lastMenu: state.UI.activeMenu,
          activeSubMenu: null,
          showHelpdeskChat: false,
          showDBRSidePanel: true,
          showStallChat: false,
        },
      }));
    } else if (item.id === menuItemsId.bdr) {
      this.handleHelpdeskChatClose();
      this.handleVideoRoomSelection(event, item.room, (err) => {
        if (!err) {
          this.setState((state) => ({
            UI: {
              ...state.UI,
              activeMenu: item,
              overlayMenu: null,
              lastMenu: state.UI.activeMenu,
              activeSubMenu: item.subMenus[DBRSubMenuIndex.Call],
              showHelpdeskChat: false,
              showDBRSidePanel: true,
              showStallChat: false,
            },
          }));
        }
      });
    } else {
      this.setState((state) => ({
        UI: { ...state.UI, overlayMenu: item, lastMenu: state.UI.activeMenu },
      }));
    }
  };

  handleSubmenuItemClick = (event, item) => {
    if (event) event.preventDefault();
    if (this.state.UI.activeSubMenu)
      if (this.state.UI.activeSubMenu.id === item.id) {
        return;
      }

    console.log(item);

    if (this.state.UI.activeMenu.id === menuItemsId.bdr) {
      if (item.id === SubMenuId.Call) {
        this.setState((prevState) => ({
          UI: {
            ...prevState.UI,
            showDBRSidePanel: true,
            activeSubMenu: item,
          },
        }));
      } else {
        this.setState((prevState) => ({
          UI: {
            ...prevState.UI,
            activeSubMenu: item,
            showDBRSidePanel: false,
          },
        }));
      }
    }

    if (this.state.UI.activeMenu.id !== menuItemsId.bdr) {
      this.setState((prevState) => ({
        UI: {
          ...prevState.UI,
          activeSubMenu: item,
          showDBRSidePanel: false,
        },
      }));
    }
  };

  closeSubMenu = (event) => {
    if (event) event.preventDefault();
    this.setState((prevState) => ({
      UI: {
        ...prevState.UI,
        activeSubMenu: null,
        showMediaModal: false,
      },
      MediaModalInfo: {
        ...prevState.MediaModalInfo,
        link: "",
        type: null,
      },
    }));
  };

  hideOverlayMenu = (event) => {
    if (event) event.preventDefault();
    if (this.state.UI.overlayMenu) {
      this.setState((state) => ({
        UI: { ...state.UI, overlayMenu: null, showAskExpertError: false },
      }));
    }
    if (this.currentOverlayCallback) {
      this.currentOverlayCallback();
      this.currentOverlayCallback = null;
    }
  };

  showMediaModal = (hotspotType, mediaLink) => {
    if (hotspotType === HotspotType.chatbot) {
      window.lastChatBotRef = mediaLink;
      mediaLink.enabled = false;
      this.handleHelpdeskChatbutton();
      return;
    }
    this.setState((prevState) => ({
      UI: {
        ...prevState.UI,
        showMediaModal: true,
      },
      MediaModalInfo: {
        ...prevState.MediaModalInfo,
        link: mediaLink ? mediaLink : "",
        type: hotspotType,
      },
    }));
  };

  handleMedialModalFromOverlay = (hotspotType, link) => {
    this.hideOverlayMenu();
    this.showMediaModal(hotspotType, link);
  };

  closeMediaModal = () => {
    this.setState((prevState) => ({
      UI: {
        ...prevState.UI,
        showMediaModal: false,
      },
      MediaModalInfo: {
        ...prevState.MediaModalInfo,
        link: "",
        type: null,
      },
    }));
  };
  //#endregion

  handleTeamOptionSelection = (event, teams) => {
    // event.preventDefault();
    window.open(teams.link, "_blank");
    this.hideOverlayMenu(event);
  };

  checkIfAudioCanPlayUnderMediaModal = () => {
    if (this.state.UI.activeMenu.id === menuItemsId.Networking) {
      if (this.state.UI.activeSubMenu)
        if (this.state.UI.activeSubMenu.id === NetworkingSubmenuId.Sessions) {
          return false;
        }
    }
    if (this.state.UI.showMediaModal) {
      if (this.state.MediaModalInfo.type === HotspotType.pdf) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  };

  handleHelpdeskChatClose = () => {
    if (window.lastChatBotRef) window.lastChatBotRef.enabled = true;
    if (this.state.HelpdeskChat.showChat) {
      this.setState({
        HelpdeskChat: {
          showChat: false,
          showButton: true,
        },
      });
    }
  };

  handleHelpdeskChatbutton = () => {
    if (this.state.HelpdeskChat.showButton) {
      this.setState({
        HelpdeskChat: {
          showChat: true,
          showButton: false,
        },
      });
    }
  };

  handleLobbyInternalState = (internalState) => {
    switch (internalState) {
      case "Infodesk":
        this.setState((prevState) => ({
          UI: {
            ...prevState.UI,
            showHelpdeskChat: true,
          },
        }));
        break;
      default:
        this.setState((prevState) => ({
          UI: {
            ...prevState.UI,
            showHelpdeskChat: false,
            showStallChat: false,
          },
          HelpdeskChat: {
            showChat: false,
            showButton: true,
          },
        }));
    }
  };

  handleSceneTutorial = (type) => {
    if (type === "end") {
      this.setState((prevState) => ({
        UI: {
          ...prevState.UI,
          isInteractable: true,
        },
      }));
    }
  };

  //#region Analytics
  handleHotspotAnalytics = (hotspotDetails) => {
    console.log(hotspotDetails.id);
    this.addHotspotAnalytics(hotspotDetails.id);
  };

  addComponentAnalytics = (location, value) => {
    //add to user
    if (value) {
      this.addHotspotAnalytics(location);
      this.addLocationAnalytics(location, value);
    }
  };

  addLocationAnalytics = (location, value) => {
    if (value) {
      updateUserLocation(this.context, location);
    }
  };

  addHotspotAnalytics = (name) => {
    //call some firebase function
    addRealtimeHotspotAnalytics(this.context, name);
  };

  addCustomHotspotAnalytics = (detials) => {
    addCustomRealtimeHotspotAnalytics(this.context, detials);
  };
  //#endregion

  //#region Dailyco Function
  handleVideoRoomSelection = async (event, room, callback) => {
    if (event) event.preventDefault();
    try {
      console.log(room);
      if (this.state.DBRVideoCall.roomAdmin) {
        console.log(this.state.DBRVideoCall.roomAdmin);
        if (this.state.DBRVideoCall.roomAdmin.roomName === room.roomName) {
          this.setState((prevState) => ({
            DBRVideoCall: {
              ...prevState.DBRVideoCall,
              room: room,
            },
          }));
          if (callback) {
            callback(null);
          }
          return;
        }
      }

      const isLive = await checkDailycoRoomStatus(room.docName);
      if (isLive) {
        this.setState((prevState) => ({
          DBRVideoCall: {
            ...prevState.DBRVideoCall,
            room: room,
          },
        }));
        if (callback) {
          callback(null);
        }
      } else {
        this.showInfoPopUp("Room is not live right now.");
        if (callback) {
          callback(true);
        }
      }
    } catch (error) {
      if (callback) {
        callback(true);
      }
      console.log(error);
    }
  };

  dailycoSetup = () => {
    checkForDailycoAdmin(this.context)
      .then((data) => {
        this.setState((prevState) => ({
          DBRVideoCall: {
            ...prevState.DBRVideoCall,
            roomAdmin: data,
          },
        }));
      })
      .catch((err) => {
        if (err.code !== "NoAdmin") console.log(err);
      });

    getDailycoRoomDetails()
      .then((data) => {
        console.log(data);
        // this.handleVideoRoomSelection(null, data[Object.keys(data)[0]])
        this.setState((prevState) => ({
          DBRVideoCall: {
            ...prevState.DBRVideoCall,
            roomOptions: data,
          },
        }));
      })
      .catch((err) => {
        console.log(err);
      });
  };

  closeDBRVideoCallSidePanel = () => {
    this.setState((prevState) => ({
      UI: {
        ...prevState.UI,
        showDBRSidePanel: false,
        activeSubMenu: null,
      },
    }));
  };

  openDBRZoomLink = (link, event) => {
    if (event) {
      event.preventDefault();
    }
    window.location.href = link;
    // window.open(link, "_blank")
  };
  //#endregion

  //#region Twilio VideoCAll

  gettingMeetingRoomErrMessage = async () => {
    const Messagedoc = await firestore
      .collection(AppString.BACKSTAGE)
      .doc(AppString.MEETINGROOMMESSAGE)
      .get();
    if (Messagedoc.data) {
      this.MeetingRoomMessage = Messagedoc.data().meetingRoomMsg;
      this.busyRoomMessage = Messagedoc.data().busyRoomMessage;
    }
  };

  checkAvailableVideoCallRoom = async (event, stallId) => {
    event.preventDefault();
    try {
      console.log(this.context);
      const slot = await getAvailableTwilioVideoCallRoom(
        this.context.email,
        stallId
      );
      let room = {
        roomId: slot.id,
        roomName: slot.name,
        roomParentId: "UltraTech",
        isAdmin: slot.isAdmin,
      };
      this.setState((state) => ({
        TwilioVideoCall: {
          ...state.TwilioVideoCall,
          room: room,
          showVideoCall: true,
          slot: slot,
          stallId: stallId,
        },
      }));
      console.log(room);
    } catch (err) {
      console.log(err);
      if (err.code === "NoRoomAvaliable") {
        swal({
          text: "Videocall rooms are occupied. Please come back later, Thanks.",
        });
      }
      this.setState((state) => ({
        UI: { ...state.UI, showAskExpertError: true },
      }));
    }
  };
  clearTwilioVideoCallRoom = async () => {
    try {
      this.setState((state) => ({
        TwilioVideoCall: { ...state.TwilioVideoCall, showVideoCall: false },
        UI: { ...state.UI, overlayMenu: null, showAskExpertError: false },
      }));

      if (this.state.TwilioVideoCall.slot.id) {
        setTimeout(async () => {
          await clearTwilioVideoCallRoom(
            this.state.TwilioVideoCall.slot.id,
            this.context.email,
            this.state.TwilioVideoCall.stallId
          );
          this.setState((state) => ({
            TwilioVideoCall: {
              ...state.TwilioVideoCall,
              slot: null,
              room: null,
            },
          }));
        }, 3000);
      } else {
        console.error("No Room Id found for user");
      }
    } catch (err) {
      console.log(err);
    }
  };
  currentSlotRest = async (event) => {
    if (event) event.preventDefault();
    try {
      console.log(this.state.TwilioVideoCall.slot);
      if (this.state.TwilioVideoCall.slot.id) {
        await clearTwilioVideoCallRoom(
          this.state.TwilioVideoCall.slot.id,
          "-1",
          this.state.TwilioVideoCall.stallId
        );
      } else {
        console.error("No Room Id found for user");
      }
    } catch (err) {
      console.log(err);
    }
  };

  showInfoPopUp = (message) => {
    swal({
      title: message,
      className: "video-swal-modal",
      button: "continue",
    });
  };

  showMeetingRoomPopup = () => {
    this.showInfoPopUp(this.MeetingRoomMessage);
  };

  showMeetingRoomBusyPopup = () => {
    this.showInfoPopUp(this.busyRoomMessage);
  };

  handleStallCallHotspot = (event, hotspotDetails) => {
    if (hotspotDetails.hotspotType !== HotspotType.videoCall) {
      return;
    }
    this.checkAvailableVideoCallRoom(event, hotspotDetails.roomDetails.id);
  };
  //#endregion

  //#region  stall chat
  handleStallChatHotspot = (event, hotspotDetails) => {
    if (hotspotDetails.hotspotType !== HotspotType.stallChat) {
      return;
    }
    if (hotspotDetails.roomDetails) {
      this.setState((prev) => ({
        UI: {
          ...prev.UI,
          showStallChat: true,
        },
        stallChat: {
          id: hotspotDetails.roomDetails.id,
        },
      }));
    } else {
      this.showInfoPopUp(
        "We are having some issue in opening chat for you. Please come back later"
      );
    }
  };
  handleStallChatHotspotClose = (event) => {
    if (event) {
      event.preventDefault();
    }
    this.setState((prev) => ({
      UI: {
        ...prev.UI,
        showStallChat: false,
      },
      stallChat: {
        id: "",
      },
    }));
  };
  //#endregion

  render() {
    return (
      <>
        {this.state.TwilioVideoCall.showVideoCall &&
          this.context &&
          this.state.TwilioVideoCall.room && (
            <MultiVideoCall
              userName={
                this.context.displayName ?? this.context.email.split("@")[0]
              }
              room={this.state.TwilioVideoCall.room}
              onCallDisconnect={this.clearTwilioVideoCallRoom}
              isOfficial={this.state.TwilioVideoCall.room.isAdmin}
              stallId={this.state.TwilioVideoCall.stallId}
              slotReset={this.currentSlotRest}
              showPopup={this.showMeetingRoomPopup}
              showBusyPopup={this.showMeetingRoomBusyPopup}
              // timerAnalytics={this.askExpertTimerAnalytics}
            ></MultiVideoCall>
          )}
        {this.state.UI.showStallChat && (
          <>
            <div className="stallChatContainer">
              <img
                src={ImageString.CLOSEBUTTON}
                className="closeButton-mediaModal"
                alt="MediaModalCLoseButton"
                onClick={this.handleStallChatHotspotClose}
                style={{
                  right: "auto",
                }}
              ></img>
              <iframe
                src={`${StaticLinks.stallChat}?${this.state.stallChat.id}`}
                title="StallChatFrame"
              ></iframe>
              <div
                className={`blocker ${
                  this.state.UI.fadeIntroImage ? "d-none" : ""
                }`}
                style={{ zIndex: "-1" }}
              >
                <div className="lds-dual-ring"></div>
              </div>
            </div>
          </>
        )}
        <div className="wrapper">
          <section className="loggedin-page has-right-menu min-height-full min-height-full image-bg">
            <CustomNotification firestore={firestore}></CustomNotification>
            {this.state.UI.showMediaModal && (
              <>
                <article
                  className={`img-bg videoBox h-100 zIndex-16`}
                  id="play"
                >
                  <div className="media-modal">
                    {this.state.MediaModalInfo.type ===
                      HotspotType.videoPlayer && (
                      <VideoPlayer
                        videoData={this.state.MediaModalInfo.link}
                        close={() => this.closeMediaModal()}
                      ></VideoPlayer>
                    )}
                    {this.state.MediaModalInfo.type ===
                      HotspotType.pdfPlayer && (
                      <PdfPlayer
                        data={this.state.MediaModalInfo.link}
                        close={() => this.closeMediaModal()}
                      ></PdfPlayer>
                    )}
                    {this.state.MediaModalInfo.type === HotspotType.pdf && (
                      <iframe
                        title={"pdf"}
                        className="media-modal-content"
                        src={this.state.MediaModalInfo.link}
                      ></iframe>
                    )}
                    {this.state.MediaModalInfo.type === HotspotType.iframe && (
                      <iframe
                        title={"iframe"}
                        className="media-modal-content-iframe"
                        src={this.state.MediaModalInfo.link}
                      ></iframe>
                    )}
                    {this.state.MediaModalInfo.type === HotspotType.video && (
                      <div className="media-modal-content">
                        <ReactPlayer
                          config={{
                            youtube: {
                              playerVars: { showinfo: 1 },
                            },
                          }}
                          playing={true}
                          url={this.state.MediaModalInfo.link}
                          controls={false}
                          width="100%"
                          height="100%"
                        />
                      </div>
                    )}
                    {this.state.MediaModalInfo.type === HotspotType.image && (
                      <img
                        title={"image"}
                        className="media-modal-content-image"
                        src={this.state.MediaModalInfo.link}
                        alt="mediaModalImage"
                      ></img>
                    )}
                    {this.state.MediaModalInfo.type !==
                      HotspotType.videoPlayer &&
                      this.state.MediaModalInfo.type !==
                        HotspotType.pdfPlayer && (
                        <img
                          src={ImageString.CLOSEBUTTON}
                          className="closeButton-mediaModal"
                          alt="MediaModalCLoseButton"
                          onClick={this.closeMediaModal}
                        ></img>
                      )}
                  </div>
                </article>
              </>
            )}
            {this.state.UI.activeMenu.id === menuItemsId.Lobby && (
              <>
                {/* <Scene
                  ShowMediaModal={this.showMediaModal}
                  initialVideo={VideoString.LOBBYLOOP}
                  firstVideoFrame={ImageString.LOBBYLOOP}
                  initialHotspot={LobbyHotspots}
                  globalBackButton={false}
                  changeComponenet={this.handleClick}
                  ratio={videoRatios}
                  customHotspotFun={this.handleCustomHotspotClick}
                  // for tut to work also pass name
                  sceneName="Lobby"
                  showTut={true}
                  tutComponent={LobbyTut}
                  showingTutorialEvent={this.handleSceneTutorial} //for handling transition pass start and end
                  changeInternalStateHandler={this.handleLobbyInternalState}
                  checkBeforeTransitionFun={this.handleVideoRoomSelection}
                  //Analytics
                  addHotspotAnalytics={this.handleHotspotAnalytics}
                  addAnalytics={(value) =>
                    this.addComponentAnalytics(AnalyticsLocations.Lobby, value)
                  }
                  //
                  handleStallCallHotspot={this.handleStallCallHotspot}
                  handleStallChatHotspot={this.handleStallChatHotspot}
                  addCustomHotspotAnalytics={this.addCustomHotspotAnalytics}
                ></Scene> */}
                {/* <iframe src="" frameborder="0"></iframe> */}
                {this.state.UI.showHelpdeskChat && (
                  <>
                    {this.context.email && this.state.HelpdeskChat.showChat && (
                      <>
                        {/* <NotLive continue={this.handleHelpdeskChatClose}></NotLive> */}
                        <ClientChat
                          channel={this.context.email}
                          user={{
                            id: this.context.email,
                            name: this.context.displayName,
                          }}
                          closeChat={this.handleHelpdeskChatClose}
                          visibility={true}
                        ></ClientChat>
                      </>
                    )}
                    {this.state.HelpdeskChat.showButton && (
                      <>
                        {/* <a data-tip data-for="chatbotInfo" >
                                                    <img
                                                        className={`helpdeskchatbtn`}
                                                        src="assets/images/chatbot.png"
                                                        alt="helpdeskButton"
                                                        onClick={this.handleHelpdeskChatbutton}
                                                    />
                                                </a>
                                                <ReactTooltip id='chatbotInfo' >
                                                    <span>How may I help you ?</span>
                                                </ReactTooltip> */}
                      </>
                    )}
                  </>
                )}
              </>
            )}
            {this.state.UI.activeMenu.id === menuItemsId.Audi && (
              <AudiScene
                changeComponenet={this.handleClick}
                ShowMediaModal={this.showMediaModal}
                initialVideo={AudiData.introVideo}
                globalBackButton={false}
                link={this.state.audiLnk}
                framePlacementStyle={AudiData.placementStyle}
                hiddeMute={false}
                //For Tutorial
                sceneName="audi"
                showTut={true}
                tutComponent={AudiTut}
                subMenus={this.state.UI.activeSubMenu}
                //Analytics
                addAnalytics={(value) => {
                  this.addComponentAnalytics(AnalyticsLocations.Audi, value);
                }}
              ></AudiScene>
            )}
            {this.state.UI.activeMenu.id === menuItemsId.Networking && (
              <>
                <Scene
                  ShowMediaModal={this.showMediaModal}
                  initialVideo={VideoString.BREAKOUTLOOP}
                  firstVideoFrame={ImageString.Breakout}
                  initialHotspot={null}
                  globalBackButton={false}
                  changeComponenet={this.handleClick}
                  ratio={videoRatios}
                  // for tut to work also pass name
                  sceneName="Networking"
                  showTut={true}
                  tutComponent={NetworkingTut}
                  showingTutorialEvent={this.handleSceneTutorial} //for handling transition pass start and end
                  //  changeInternalStateHandler={this.handleLobbyInternalState}
                  //Analytics
                  addAnalytics={(value) =>
                    this.addComponentAnalytics(
                      AnalyticsLocations.Networking,
                      value
                    )
                  }
                ></Scene>
              </>
            )}
            {this.state.UI.activeMenu.id === menuItemsId.bdr &&
              this.state.DBRVideoCall.room && (
                <>
                  <AudiScene
                    changeComponenet={this.handleClick}
                    ShowMediaModal={this.showMediaModal}
                    initialVideo={DBRData.introVideo}
                    globalBackButton={false}
                    link={""}
                    framePlacementStyle={DBRData.placementStyle}
                    hiddeMute={false}
                    //For Tutorial
                    sceneName="dbr"
                    showTut={true}
                    tutComponent={DBRTut}
                    subMenus={this.state.UI.activeSubMenu}
                    //Analytics
                    addAnalytics={(value) => {
                      this.addComponentAnalytics(AnalyticsLocations.DBR, value);
                    }}
                    //useDailyCo
                    useDailyCo={true}
                    DailyCoData={{
                      goToLobby: this.handleClick,
                      name: this.context.displayName
                        ? this.context.displayName
                        : this.context.email.split("@")[0],
                      room: this.state.DBRVideoCall.room,
                      isAdmin:
                        this.state.DBRVideoCall.roomAdmin === null
                          ? false
                          : this.state.DBRVideoCall.roomAdmin.roomName ===
                            this.state.DBRVideoCall.room.roomName,
                      autoInitalize: true,
                      showSidePanel: this.state.UI.showDBRSidePanel,
                      hideSidePanel: this.closeDBRVideoCallSidePanel,
                    }}
                    videoInFrame={false}
                    //
                  ></AudiScene>
                </>
              )}
            {this.state.UI.overlayMenu && (
              <>
                {this.state.UI.overlayMenu.id === menuItemsId.TeamBuilding && (
                  <>
                    <ListContainer
                      data={TeamsData}
                      hideOverlayMenu={this.hideOverlayMenu}
                      handleTeamOptionSelection={this.handleTeamOptionSelection}
                      //Analytics
                      // addAnalytics={(value) => {
                      //     this.addComponentAnalytics(AnalyticsLocations.Teambuilding, value);
                      // }}
                    ></ListContainer>
                  </>
                )}
                {/* {
                                    (this.state.UI.overlayMenu.id === menuItemsId.TeamBuilding || this.state.UI.overlayMenu.id === menuItemsId.Audi) &&
                                    <NotLive continue={this.hideOverlayMenu}></NotLive>
                                } */}
              </>
            )}
            {this.state.UI.showSurveyPopup && this.state.UI.surveyDetails && (
              <>
                <ListContainer
                  data={this.state.UI.surveyDetails}
                  hideOverlayMenu={() => {
                    this.setState((state) => ({
                      UI: {
                        ...state.UI,
                        showSurveyPopup: false,
                        surveyDetails: null,
                      },
                    }));
                  }}
                  handleTeamOptionSelection={(event, option) => {
                    this.showMediaModal(HotspotType.iframe, option.link);
                  }}
                ></ListContainer>
              </>
            )}
            {this.state.UI.activeMenu.id === menuItemsId.Networking &&
              this.state.UI.activeSubMenu && (
                <>
                  {/* {
                                    this.state.UI.activeSubMenu.id === NetworkingSubmenuId.Speaker &&
                                    <article className={`img-bg videoBox h-100 zIndex50`} id="play">
                                        <div className="media-modal">
                                            <iframe title={"pdf"} className="media-modal-content" src={NetworkingLounge.speakerPdf}></iframe>
                                            <img src={ImageString.CLOSEBUTTON} className="closeButton-mediaModal" alt="MediaModalCLoseButton" onClick={this.closeSubMenu} ></img>
                                        </div>
                                    </article>
                                }
                                {
                                    this.state.UI.activeSubMenu.id === NetworkingSubmenuId.Sessions &&
                                    <>
                                        <VideoPlayer videoData={VideoPlayerData} close={() => this.closeSubMenu()}></VideoPlayer>
                                    </>
                                }
                                {
                                    this.state.UI.activeSubMenu.id === NetworkingSubmenuId.Connect &&
                                    <Connect close={this.closeSubMenu}></Connect>
                                } */}
                  {this.state.UI.activeSubMenu.id ===
                    NetworkingSubmenuId.Chat && (
                    // <div className="scrollableIframeParent">
                    //     <iframe className="publicChatBox" src="/Chat/index.html" title="chatFrame"></iframe>
                    // </div>
                    <div className="stallChatContainer">
                      <img
                        src={ImageString.CLOSEBUTTON}
                        className="closeButton-mediaModal"
                        alt="MediaModalCLoseButton"
                        onClick={this.closeSubMenu}
                        style={{
                          right: "auto",
                        }}
                      ></img>
                      <iframe
                        src={`${StaticLinks.publicChat}?private`}
                        title="publicChat"
                      ></iframe>
                      <div
                        className={`blocker ${
                          this.state.UI.fadeIntroImage ? "d-none" : ""
                        }`}
                        style={{ zIndex: "-1" }}
                      >
                        <div className="lds-dual-ring"></div>
                      </div>
                    </div>
                  )}
                </>
              )}
            {this.state.UI.activeSubMenu &&
              this.state.UI.activeMenu.id === menuItemsId.bdr && (
                <>
                  {this.state.UI.activeSubMenu.id === SubMenuId.GoToStage && (
                    <>
                      <div className="lobbyTutContainer">
                        <div className="tutCardContainer tutCardContainer-sm pd-b-2">
                          <div className="tutCardContainer-header  bg-red">
                            <div>Zoom Call</div>
                          </div>
                          <div className="tutCardContainer-body">
                            Please click on the join button to enter Digital
                            Board Room.
                          </div>
                          <div className="text-center">
                            <button
                              className="tutCardButton btn  btn-yellow mg-t30"
                              onClick={(e) => this.closeSubMenu(e)}
                            >
                              CANCEL
                            </button>
                            <button
                              className="tutCardButton btn  btn-yellow mg-t30"
                              onClick={(e) =>
                                this.openDBRZoomLink(this.state.zoomlink, e)
                              }
                              style={{ marginLeft: "1rem" }}
                            >
                              JOIN
                            </button>
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                </>
              )}
            {!this.state.UI.showGlobalChat && (
              <div
                className="chatButton"
                onClick={() =>
                  this.setState((prev) => ({
                    UI: {
                      ...prev.UI,
                      showGlobalChat: true,
                    },
                  }))
                }
              >
                CHAT
              </div>
            )}
            {this.state.UI.showGlobalChat && (
              <div className="stallChatContainer stallChatContainer-global">
                <img
                  src={ImageString.CLOSEBUTTON}
                  className="closeButton-mediaModal"
                  alt="MediaModalCLoseButton"
                  onClick={() =>
                    this.setState((prev) => ({
                      UI: {
                        ...prev.UI,
                        showGlobalChat: false,
                      },
                    }))
                  }
                ></img>
                <iframe
                  src={`${StaticLinks.publicChat}?public`}
                  title="publicChat"
                ></iframe>
                <div
                  className={`blocker ${
                    this.state.UI.fadeIntroImage ? "d-none" : ""
                  }`}
                  style={{ zIndex: "-1" }}
                >
                  <div className="lds-dual-ring"></div>
                </div>
              </div>
            )}
            {
              <footer className="footerBox">
                {this.state.UI.overlayMenu && (
                  <>
                    {this.state.UI.overlayMenu.id === menuItemsId.MyProfile && (
                      <div>
                        <MyProfile
                          activeMenu={this.state.UI.activeMenu}
                          close={this.hideOverlayMenu}
                          ShowMediaModal={this.handleMedialModalFromOverlay}
                        ></MyProfile>
                      </div>
                    )}
                  </>
                )}
                {this.state.UI.activeMenu &&
                  !this.state.UI.activeMenu.subMenus && (
                    <Menu
                      items={this.state.UI.menuItems}
                      mainMenuState={
                        this.state.UI.overlayMenu
                          ? this.state.UI.overlayMenu.id
                          : this.state.UI.activeMenu.id
                      }
                      onMenuItemClick={this.handleClick}
                      canInteract={this.state.UI.isInteractable}
                      activeMenu={this.state.UI.activeMenu}
                    ></Menu>
                  )}
                {this.state.UI.activeMenu.subMenus && (
                  <Menu
                    items={this.state.UI.activeMenu.subMenus}
                    mainMenuState={
                      this.state.UI.activeSubMenu
                        ? this.state.UI.activeSubMenu.id
                        : -1
                    }
                    onMenuItemClick={this.handleSubmenuItemClick}
                    canInteract={this.state.UI.isInteractable}
                    backButton={true}
                    onBackButtonClick={(e) =>
                      this.handleClick(e, menuItems[menuItemsIndex.Lobby])
                    }
                    activeMenu={this.state.UI.activeMenu}
                  ></Menu>
                )}
                {this.state.UI.activeSubMenu &&
                  this.state.UI.activeMenu.id === menuItemsId.Audi && (
                    <>
                      <div className={`submenu-container active expended`}>
                        {this.state.UI.activeSubMenu.id === SubMenuId.QNA && (
                          <QNA
                            headerName={"Q&A"}
                            onHeadingClick={this.closeSubMenu}
                            QNACollection={"qnaAudi"}
                            QNAReplyCollection={"qnaAudiReply"}
                            canReply={true}
                            moderated={true}
                          ></QNA>
                        )}
                        {this.state.UI.activeSubMenu.id === SubMenuId.POll && (
                          <PublicPoll
                            onHeadingClick={this.closeSubMenu}
                            PollAdmin_Col={"pollAdmin"}
                            PollAdmin_Doc={"adminAccess"}
                            Poll_Doc={"poll"}
                          ></PublicPoll>
                        )}
                      </div>
                    </>
                  )}
                {this.state.UI.activeSubMenu &&
                  this.state.UI.activeMenu.id === menuItemsId.bdr && (
                    <>
                      {this.state.UI.activeSubMenu.id === SubMenuId.QNA && (
                        <div className={`submenu-container active expended`}>
                          <QNA
                            headerName={"Q&A"}
                            onHeadingClick={this.closeSubMenu}
                            QNACollection={"qna-dbr"}
                            QNAReplyCollection={"qnaReply-dbr"}
                            canReply={true}
                            moderated={true}
                          ></QNA>
                        </div>
                      )}
                      {this.state.UI.activeSubMenu.id === SubMenuId.POll && (
                        <div className={`submenu-container active expended`}>
                          <PublicPoll
                            onHeadingClick={this.closeSubMenu}
                            PollAdmin_Col={"pollAdmin-dbr"}
                            PollAdmin_Doc={"adminAccess"}
                            Poll_Doc={"poll-dbr"}
                          ></PublicPoll>
                        </div>
                      )}
                    </>
                  )}
              </footer>
            }
          </section>
        </div>
        {this.checkIfAudioCanPlayUnderMediaModal() &&
          this.state.UI.activeMenu.id !== menuItemsId.bdr &&
          this.state.UI.activeMenu.id !== menuItemsId.Audi &&
          !this.state.TwilioVideoCall.showVideoCall && (
            <ReactAudioPlayer
              src="/3dAssets/music/ambientMusic.mp3"
              autoPlay
              volume={0.1}
              loop={true}
              preload="auto"
              ref={this.currentAudioRef}
            />
          )}
      </>
    );
  }
}
Home.contextType = UserContext;

export default Home;
